import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@fox1ck-org/auth/react";
import { brandDefaultThemeOf, getBrand } from "@fox1ck-org/auth/saas";
import { ThemeProvider, TooltipProvider } from "@fox1ck-org/ui";
import { Toaster } from "@fox1ck-org/ui/toast";
import { Gate } from "@/components/layout/gate";
import { auth } from "@/lib/auth";
import { loadPageBrand } from "@/lib/brand";
import App from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
      retry: 1,
    },
  },
});

void loadPageBrand().then(() =>
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <ThemeProvider storageKey="ui-theme" defaultTheme={brandDefaultThemeOf(getBrand().brand) ?? "system"}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider auth={auth}>
            <TooltipProvider delayDuration={300}>
              <BrowserRouter>
                <Gate>
                  <App />
                </Gate>
              </BrowserRouter>
              <Toaster position="bottom-right" richColors closeButton />
            </TooltipProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </React.StrictMode>,
  ),
);
